import React from 'react';
import AboutPage from '../pages/AboutPage';
import { getCurrentUser, subscribeToAuthState, type User } from '../services/graphql/authService';
import { useState, useEffect } from 'react';
import { useServiceKey } from '../hooks/useServiceKey';

/**
 * AboutPageWrapper component that wraps AboutPage and provides the necessary props
 */
const AboutPageWrapper: React.FC = () => {
  const [currentUser, setCurrentUser] = useState<User | null>(null);
  const { serviceConfig } = useServiceKey();

  // Get current user from GraphQL auth
  useEffect(() => {
    // Initial fetch of user
    getCurrentUser()
      .then((user) => setCurrentUser(user))
      .catch(() => setCurrentUser(null));

    // Subscribe to auth state changes
    const unsubscribe = subscribeToAuthState((user) => {
      setCurrentUser(user);
    });

    return () => {
      unsubscribe();
    };
  }, []);

  return <AboutPage currentUser={currentUser} serviceConfig={serviceConfig} />;
};

export default AboutPageWrapper;
